<template>
    <div class="mt-5">
        <header class="cover b-curse shadow">
            <div class="container py-5">
                <div class="row">
                    <div class="col-md-12 d-flex" id="title">
                        <img :src="curse ? curse.cover : ''" alt="" height="200" class="shadow">
                        <article class="pl-5">
                            <h3 data-purpose="lead-title"> {{curse ? curse.title : ''}}</h3>
                            <Rating :rating="curse ? curse.rating_count : 0" :students="curse ? curse.students : 0"/>
                            <p align="justify" class="font-weight-light d-none d-md-block">{{curse ? curse.description : ''}}</p>
                            <ul class="list-inline font-gray-dark font-min">
                                <li class="list-inline-item" v-b-tooltip.hover title="Categoría" v-if="curse"><i class="fas fa-stream font-gray-dark"></i> {{ curse.category.name}}</li>
                                <li class="list-inline-item" v-b-tooltip.hover title="Idioma del curso" v-if="curse"><i class="fas fa-language font-gray-dark"></i> {{  curse.lenguage.name}}</li>
                                <li class="list-inline-item" v-b-tooltip.hover title="Fecha de publicación" v-if="curse"><i class="fas fa-calendar-minus font-gray-dark"></i> {{ curse.created_at | timeDate}}</li>
                            </ul>
                            <div class="__onlogin" v-if="isLoggedIn">
                                <button class="btn b-orange shadow-sm" @click="contentCurse()"><i class="fas fa-play-circle"></i> Visualizar Curso</button>
                                <b-button v-if="typeOrigin == 'student'" type="button" :class="favorite ? 'b-red' : 'font-weight-bold bg-transparent text-danger'" :disabled="typeOrigin != 'student' || loading.favorite" @click="actionFavorite">
                                    <b-spinner v-if="loading.favorite" small label="Espere ..."></b-spinner>
                                    <i class="fas fa-heart" v-if="!loading.favorite && favorite"></i>
                                    <i class="far fa-heart" v-if="!loading.favorite && !favorite"></i>
                                    {{ favorite ? ' Favorito' : ' Agregar a Favorito'}}
                                </b-button>
                            </div>
                            <div v-else>
                                <router-link to="/registrar" class="font-orange">Registrate</router-link>  de manera gratuíta para ver este curso.
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </header>
        <section class="b-white">
            <div class="container py-5">
                <div class="row">

                    <div class="col-md-6 col-sm-12 offset-md-3 offset-sm-0 text-center">
                        <h4 class="font-weight-light">Capacitador</h4>
                        <div class="__trainer" v-if="curse">
                            <div class="_trainer_headeralign-items-center">
                                <img :src="curse.trainer.avatar" alt="" height="60" width="60" class="rounded-circle">
                                <div class="__name ml-2">{{curse.trainer.name}}</div>
                            </div>
                            <div class="_trainer_detail">
                                <ul class="list-unstyled" v-if="curse">
                                     <li><i class="fas fa-video font-gray-dark"></i> Cursos Publicados: {{curse.trainer.trainer_info.curses_published}}</li>
                                    <li><i class="fas fa-quote-right font-gray-dark"></i> Biografía: {{curse.trainer.trainer_info.biography}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Rating from './components/view/Rating'
import Comment from './components/view/Comment'
import RatingTrainer from './components/view/RatingTrainer' //TODO: No se implemento la reputación para el capacitador
export default {
    components:{
        'Rating': Rating,
        'RatingTrainer': RatingTrainer,
        'Comment': Comment
    },
    data() {
        return {
            favorite: false,
            downloading: false,
            loading: {
                favorite: false,
            },
            curse: null,
        }
    },
    methods:{
        actionFavorite(){
            this.loading.favorite = true
            this.api.get('student/curse/favorite/' + this.curse.id).then(({data}) => {
                this.loading.favorite = false
                this.favorite = !this.favorite
                this.toast(data.message)
            }).catch(err => {
                this.loading.favorite = false
            })
        },
        contentCurse(){
            this.$router.push('/curse/content/' + this.curse.url_public)
        },
        toast(message){
            this.$bvToast.toast(message, {
                title: "Kllaar.com",
                variant: 'success',
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true
            })
        },
    },
    computed:{
        typeOrigin: function(){ return this.$store.getters.typeOrigin },
        isLoggedIn: function(){ return this.$store.getters.isLoggedIn}
    },
    created() {
        let url_public = this.$route.params.url_public
        let isStudent = false
        if(this.isLoggedIn){
            if(this.typeOrigin == 'student'){
                isStudent = true
            }
        }
        this.downloading = true
        this.api.get(isStudent ? 'curse/forstudent/cur/' + url_public: 'curse/view/' + url_public).then(({data}) => {
            this.curse = data.body
            if(data.body.favorite){
                this.favorite = true
            }
            this.downloading = false
        }).catch(err => {
            if(err.response.status === 404){
              swal("Curso no disponible", "El curso al que intentas acceder, aún no se encuentra disponible. Vuelve a intentarlo más tarde", "error")
                  .then(()  => {
                    this.$router.push(
                      {name: 'cursos-home'}
                      )
                  })
            }
            this.downloading = false
            console.log(err)
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#public/curse/CurseView.vue